import { Injectable } from '@angular/core';
import { WebStorageService, WindowService } from '@front-shared-lib';

export type TthemePref = 'system' | 'light' | 'dark';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  themeMode: TthemePref = 'system';
  currentIcon = 'computer';
  toggle = false;
  private prefersDark;

  constructor(
    private storage: WebStorageService,
    private windowService: WindowService
  ) {}

  toggleTheme(themeMode: TthemePref, currentIcon: string) {
    this.themeMode = themeMode;
    this.storage.set('theme', themeMode);
    this.currentIcon = currentIcon;
    switch (themeMode) {
      case 'dark':
        this.setTheme(true);
        break;
      case 'light':
        this.setTheme(false);
        break;
      case 'system':{
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

        this.setTheme(prefersDark.matches);
        break;
      }
    }
  }

  setTheme(isDark: boolean) {
    if (isDark) {
      document.body.classList.add('dark-theme');
    } else {
      document.body.classList.remove('dark-theme');
    }
  }

  initTheme() {
    let theme = this.storage.get('theme') as TthemePref;

    console.log('store theme,', theme);
    let currentIcon : string;

    switch (theme) {
      case 'dark':
        currentIcon = 'dark_mode';
        break;
      case 'light':
        currentIcon = 'light_mode';
        break;
      default: {
        currentIcon = 'computer';
        theme = 'system';
        break;
      }
    }
    this.toggleTheme(theme, currentIcon);
    this.watchMedia();
  }

  watchMedia() {
    window.matchMedia('(prefers-color-scheme: dark)')
      .addEventListener('change', ({ matches }) => {
        if (this.themeMode === 'system') {
          this.setTheme(matches);
        }
      });
  }

  loadApp() {
    if (this.windowService.getWindow()) {
      this.prefersDark = this.windowService.getWindow()?.matchMedia('(prefers-color-scheme: dark)');
      // Listen for changes to the prefers-color-scheme media query
      this.prefersDark.addListener((e) => this.checkToggle(e.matches));
      this.checkToggle(this.prefersDark.matches);
    }
  }

  checkToggle(val: boolean) {
    this.toggle = val;
    if (this.windowService.getWindow()) {
      this.windowService.doc.body.classList.toggle('dark', val);
    }
  }
}
